import { useTranslation } from "react-i18next";

import { useSnoozeTypeOptions as useSnoozeTypeOptionsBase } from "components/SnoozeModal/hooks";

import type { DropdownItemProps } from "components/Dropdown";
import type { SNOOZE_TYPES } from "models";

export const useSnoozeTypeOptions = () => {
  const { t } = useTranslation();
  const { snoozeTypeOptions } = useSnoozeTypeOptionsBase();
  const selectAllOption = { key: "all", value: "all", text: t("v8_all", "All") };

  const allSnoozeTypeOptions: DropdownItemProps<SNOOZE_TYPES | string>[] = [selectAllOption, ...snoozeTypeOptions];
  return { snoozeTypeOptions: allSnoozeTypeOptions };
};
